import CopyPill from '../../reusable/InfoPanel/CopyPill';
import InfoPanel from '../../reusable/InfoPanel/InfoPanel';
import InfoField from '../../reusable/InfoPanel/InfoField';
import InfoAccordion from '../../reusable/InfoPanel/InfoAccordion';
import InfoRow from '../../reusable/InfoPanel/InfoRow';
import { t } from '../../i18n/i18n';
import { connectionFields, MOBILE_APPS, NOTICE, OTHER_PLATFORMS, PRIMARY } from './data';
import './Downloads.scss';

/**
 * Downloads — 1:20244.
 *
 * Built entirely from `src/reusable/InfoPanel/`: this page is a card of
 * installers, the two connection settings under them, and a second card of
 * everything that is not MetaTrader 5. Nothing here is page-specific enough to
 * need styling of its own.
 */
export default function Downloads() {
  return (
    <div className="downloads">
      <header className="page-head">
        <h1 className="page-head__title">{t('Downloads')}</h1>
        <p className="page-head__meta">{t(NOTICE)}</p>
      </header>

      <InfoPanel title={t('Alpha Capital mobile app')}>
        <div className="ip-rows">
          {MOBILE_APPS.map((item) => (
            <InfoRow
              key={item.id}
              logo={item.logo}
              label={t(item.label)}
              note={t(item.note)}
              href={item.href}
            />
          ))}
        </div>
      </InfoPanel>

      <InfoPanel title={PRIMARY.title} meta={t(PRIMARY.meta)}>
        <div className="ip-rows">
          {PRIMARY.downloads.map((item) => (
            <InfoRow
              key={item.id}
              logo={item.logo}
              label={t(item.label)}
              note={t(item.note)}
              href={item.href}
            />
          ))}
        </div>

        {/* The installer is only half of it — a client is useless without the
            server to point it at, so the two settings sit in the same card
            rather than somewhere the trader has to go and find them. */}
        <div className="ip-fields">
          {connectionFields().map((field) => (
            <InfoField
              key={field.id}
              label={t(field.label)}
              value={t(field.value)}
              wide={field.wide}
              action={
                field.copy && <CopyPill value={field.value} label={t(field.label)} />
              }
            />
          ))}
        </div>
      </InfoPanel>

      <InfoPanel title={t('Other platforms')}>
        <div className="ip-rows">
          {OTHER_PLATFORMS.map((item) =>
            item.options ? (
              <InfoAccordion
                key={item.id}
                logo={item.logo}
                label={t(item.label)}
                note={t(item.note)}
                options={item.options.map((opt) => ({ ...opt, label: t(opt.label), note: t(opt.note) }))}
              />
            ) : (
              <InfoRow
                key={item.id}
                logo={item.logo}
                label={t(item.label)}
                note={t(item.note)}
                href={item.href}
              />
            ),
          )}
        </div>
      </InfoPanel>
    </div>
  );
}
